/**
 * OpenAI Ads Measurement Pixel.
 * Prefer early init from public/index.html; this module is a safe fallback
 * and the place to fire conversion events.
 */

const PIXEL_ID = "CxAZGeXfo6WXYTw3tTYkyg";
const SDK_URL = "https://bzrcdn.openai.com/sdk/oaiq.min.js";

function ensureOaiqStub() {
  if (typeof window === "undefined") return null;
  if (typeof window.oaiq === "function") return window.oaiq;

  const q = function () {
    q.q.push(arguments);
  };
  q.q = [];
  window.oaiq = q;
  return q;
}

function injectSdk() {
  if (typeof document === "undefined") return;
  if (document.querySelector(`script[src="${SDK_URL}"]`)) return;

  const js = document.createElement("script");
  js.async = true;
  js.src = SDK_URL;
  const first = document.getElementsByTagName("script")[0];
  if (first?.parentNode) {
    first.parentNode.insertBefore(js, first);
  } else {
    (document.head || document.documentElement).appendChild(js);
  }
}

/**
 * Ensure the pixel stub + SDK are present, then init.
 * Safe to call multiple times.
 */
export function initOpenAIPixel({ debug = process.env.NODE_ENV !== "production" } = {}) {
  try {
    const oaiq = ensureOaiqStub();
    if (!oaiq) return;
    injectSdk();
    oaiq("init", { pixelId: PIXEL_ID, debug: Boolean(debug) });
  } catch (err) {
    console.warn("[OpenAI Pixel] init failed", err);
  }
}

/**
 * Fire Trial Started (standard event: trial_started).
 */
export function trackOpenAITrialStarted() {
  try {
    initOpenAIPixel();
    if (typeof window === "undefined" || typeof window.oaiq !== "function") {
      console.warn("[OpenAI Pixel] oaiq unavailable; trial_started not sent");
      return;
    }
    window.oaiq("measure", "trial_started", {
      type: "plan_enrollment",
      plan_id: "trial",
      amount: 0,
      currency: "USD",
    });
  } catch (err) {
    console.warn("[OpenAI Pixel] trial_started failed", err);
  }
}
